import React, { createContext, useContext, ReactNode, useState } from 'react'

interface LocationContextProps {
  showLocationModal: boolean
  loader: boolean
  setShowLocationModal: React.Dispatch<React.SetStateAction<boolean>>
  setLoader: React.Dispatch<React.SetStateAction<boolean>>
}

const LocationContext = createContext<LocationContextProps | undefined>(
  undefined
)

export const LocationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [showLocationModal, setShowLocationModal] = useState<boolean>(false)
  const [loader, setLoader] = useState<boolean>(false)

  return (
    <LocationContext.Provider
      value={{ loader, showLocationModal, setShowLocationModal, setLoader }}
    >
      {children}
    </LocationContext.Provider>
  )
}

export const useLocationContext = () => {
  const context = useContext(LocationContext)

  if (!context) {
    throw new Error('useLocationContext must be used within a LocationProvider')
  }

  return context
}
